// additional libs
// import "./utils/lite-youtube-embed";

import "../scss/styles-contact.scss";

import { createComponent } from "@bigyouth/base";
import * as features from "./features/exports/contact";

Object.values(features).forEach(createComponent); 
